import { gql } from '@apollo/client';
import GSS_CLASSROOM_SETTINGS_FRAGMENT from '../../fragments/gss-classroom-settings';

const GET_GSS_CLASSROOM_SETTINGS = gql`
  query gssClassroomSettings($where: PliClassroomSettingsWhereInput!) {
    gssClassroomSettings(where: $where) {
      ...BaseGssClassroomSettings
    }
  }
  ${GSS_CLASSROOM_SETTINGS_FRAGMENT}
`;

export default GET_GSS_CLASSROOM_SETTINGS;
